import { PiArrowUpFill } from "react-icons/pi";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { getShippingMetrics, getShippingRecords } from "../../api/ship";
import ShippingTable from "./ShippingTable";
import DropoffTable from "./DropoffTable";
import { Tabs } from "antd";
import Loading from "../shared/Loading";

const items = [
  {
    key: "1",
    label: "Local",
    children: <ShippingTable />,
  },
  {
    key: "2",
    label: "International (Drop Off)",
    children: <DropoffTable />,
  },
];

const Shipping = () => {
  const { data, isLoading } = useQuery("shipping-metrics", getShippingMetrics);

  return (
    <div className="w-full h-full pt-5 px-5 pb-40 font-dmsans">
      {isLoading ? (
        <Loading />
      ) : (
        <div className="flex flex-col gap-5">
          <div className="space-y-1">
            <div className="font-dmsans font-bold text-[22px] text-[#070E05]">
              Shipping
            </div>
            <Link to="addresses">
              <div className="flex items-center text-[#2121F1] font-medium text-[15px]">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="w-[20px]"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.5 10.5005C14.5 9.11924 13.3808 8 12.0005 8C10.6192 8 9.5 9.11924 9.5 10.5005C9.5 11.8808 10.6192 13 12.0005 13C13.3808 13 14.5 11.8808 14.5 10.5005Z"
                    stroke="#2121F1"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9995 21C10.801 21 4.5 15.8984 4.5 10.5633C4.5 6.38664 7.8571 3 11.9995 3C16.1419 3 19.5 6.38664 19.5 10.5633C19.5 15.8984 13.198 21 11.9995 21Z"
                    stroke="#2121F1"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>All Shipping address</span>
              </div>
            </Link>
          </div>
          <div
            className="grid gap-6"
            style={{
              gridTemplateColumns: "repeat(auto-fit, minmax(48.5%, 0fr))",
            }}
          >
            <div className="bg-white rounded-lg p-5">
              <div className="w-full flex flex-col gap-1">
                <div className="text-[#181819E5] font-bold text-[14px]">
                  Pending Shipments
                </div>
                <div className="text-[#14142B] text-[26px] font-bold">
                  {data && data["pending"]}
                </div>
                <div className=" bg-[#27AE601A] text-[#27AE60] text-[13px] w-fit rounded-[3px] px-[3px] flex items-center gap-1">
                  <PiArrowUpFill /> 20%
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg p-4">
              <div className="w-full flex flex-col gap-1">
                <div className="text-[#181819E5] font-bold text-[14px]">
                  Total Shipped Shipments
                </div>
                <div className="text-[#14142B] text-[26px] font-bold">
                  {data && data["shipped"]}
                </div>
                <div className=" bg-[#27AE601A] text-[#27AE60] text-[13px] w-fit rounded-[3px] px-[3px] flex items-center gap-1">
                  <PiArrowUpFill /> 20%
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg p-4">
              <div className="w-full flex flex-col gap-1">
                <div className="text-[#181819E5] font-bold text-[14px]">
                  Shipments in Transit/Delivered
                </div>
                <div className="flex w-full items-center">
                  <div className="w-1/2 space-y-1">
                    <div className="text-[#00000080] text-[12px] py-1">
                      In Transit
                    </div>
                    <div className="text-[#14142B] text-[26px] font-bold">
                      {data && data["in_transit"]}
                    </div>
                    <div className=" bg-[#27AE601A] text-[#27AE60] text-[13px] w-fit rounded-[3px] px-[3px] flex items-center gap-1">
                      <PiArrowUpFill /> 20%
                    </div>
                  </div>
                  <div className="w-1/2 space-y-1">
                    <div className="text-[#00000080] text-[12px] py-1">
                      Delivered
                    </div>
                    <div className="text-[#14142B] text-[26px] font-bold">
                      {data && data["delivered"]}
                    </div>
                    <div className=" bg-[#27AE601A] text-[#27AE60] text-[13px] w-fit rounded-[3px] px-[3px] flex items-center gap-1">
                      <PiArrowUpFill /> 20%
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg p-4">
              <div className="flex flex-col gap-1">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-[#181819E5] text-[14px] font-bold tracl">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.9773 4.44209L22.246 17.0572C22.406 17.4338 22.476 17.7399 22.496 18.058C22.536 18.8012 22.276 19.5236 21.7661 20.0795C21.2562 20.6334 20.5663 20.9604 19.8164 21H5.1789C4.86896 20.9812 4.55901 20.9108 4.26906 20.8018C2.8193 20.2172 2.11942 18.5723 2.70932 17.1464L10.0281 4.43317C10.278 3.98628 10.658 3.60082 11.1279 3.35309C12.4877 2.59902 14.2174 3.09447 14.9773 4.44209ZM13.3675 12.7557C13.3675 13.2314 12.9776 13.6287 12.4977 13.6287C12.0178 13.6287 11.6178 13.2314 11.6178 12.7557V9.95248C11.6178 9.47585 12.0178 9.09039 12.4977 9.09039C12.9776 9.09039 13.3675 9.47585 13.3675 9.95248V12.7557ZM12.4977 17.0176C12.0178 17.0176 11.6178 16.6202 11.6178 16.1456C11.6178 15.669 12.0178 15.2726 12.4977 15.2726C12.9776 15.2726 13.3675 15.6601 13.3675 16.1347C13.3675 16.6202 12.9776 17.0176 12.4977 17.0176Z"
                        fill="#D3180C"
                      />
                    </svg>
                    <span>Need attention</span>
                    <div>
                      <svg
                        width="11"
                        height="12"
                        viewBox="0 0 11 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.66706 1.375H3.33256C1.82206 1.375 0.875061 2.4445 0.875061 3.958V8.042C0.875061 9.5555 1.81756 10.625 3.33256 10.625H7.66656C9.18206 10.625 10.1251 9.5555 10.1251 8.042V3.958C10.1251 2.4445 9.18206 1.375 7.66706 1.375Z"
                          stroke="#7B7B7B"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.49738 8V6"
                          stroke="#7B7B7B"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.49497 4.10254H5.49997"
                          stroke="#7B7B7B"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="">
                    <Link
                      to=""
                      className="text-[#2F66F6] font-medium text-[13px]"
                    >
                      See all
                    </Link>
                  </div>
                </div>
                <div className="flex w-full items-center">
                  <div className="space-y-1 mt-4 w-1/2">
                    <div className="text-[#00000080] text-[12px] py-1">All</div>
                    <div className="text-[#14142B] text-[28px] font-bold">
                      {data && data["need_attention"]}
                    </div>
                  </div>
                  {/* <div className="space-y-1 mt-4 w-1/2">
                  <div className="text-[#00000080] text-[12px] py-1">
                    International
                  </div>
                  <div className="text-[#14142B] text-[28px] font-bold">0</div>
                </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="w-full bg-white rounded-lg p-4 gap-4 flex flex-col h-fit">
            <div className="chart-heading flex flex-col font-dmsans">
              <div className="text-[#181819E5] font-bold text-[14px]">
                Shipments
              </div>
              <Tabs defaultActiveKey="1" items={items} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Shipping;
